import { useState } from 'react'
import { Clock } from 'lucide-react'

interface Props {
  onSchedule: (iso: string) => void
  onClose: () => void
}

function nextWeekday(day: number, hour: number): Date {
  const d = new Date()
  d.setHours(hour, 0, 0, 0)
  const current = d.getDay()
  let diff = day - current
  if (diff <= 0) diff += 7
  d.setDate(d.getDate() + diff)
  return d
}

function todayAt(hour: number): Date | null {
  const d = new Date()
  if (d.getHours() >= hour - 1) return null
  d.setHours(hour, 0, 0, 0)
  return d
}

export function SchedulePopover({ onSchedule, onClose }: Props) {
  const [custom, setCustom] = useState(false)
  const [date, setDate] = useState('')
  const [time, setTime] = useState('09:00')

  const presets = [
    { label: 'Later today — 5pm', date: todayAt(17) },
    { label: 'Tomorrow morning — 9am', date: (() => { const d = new Date(); d.setDate(d.getDate() + 1); d.setHours(9, 0, 0, 0); return d })() },
    { label: 'Monday morning — 9am', date: nextWeekday(1, 9) },
  ].filter(p => p.date !== null) as { label: string; date: Date }[]

  const handleCustomSubmit = () => {
    if (!date) return
    const iso = new Date(`${date}T${time}:00`).toISOString()
    onSchedule(iso)
    onClose()
  }

  return (
    <div className="absolute bottom-full mb-2 left-0 z-50 bg-white border border-gray-200 rounded-xl shadow-xl p-3 w-64">
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2 flex items-center gap-1">
        <Clock className="w-3 h-3" /> Schedule send
      </p>
      {!custom ? (
        <div className="space-y-1">
          {presets.map(p => (
            <button
              key={p.label}
              type="button"
              onClick={() => { onSchedule(p.date.toISOString()); onClose() }}
              className="w-full text-left px-3 py-2 rounded-lg text-sm text-gray-700 hover:bg-gray-50"
            >
              {p.label}
            </button>
          ))}
          <button
            type="button"
            onClick={() => setCustom(true)}
            className="w-full text-left px-3 py-2 rounded-lg text-sm text-indigo-600 hover:bg-indigo-50"
          >
            Custom date & time…
          </button>
        </div>
      ) : (
        <div className="space-y-2">
          <input type="date" value={date} onChange={e => setDate(e.target.value)}
            min={new Date().toISOString().split('T')[0]}
            className="input w-full text-sm" />
          <input type="time" value={time} onChange={e => setTime(e.target.value)}
            className="input w-full text-sm" />
          <div className="flex gap-2">
            <button type="button" onClick={() => setCustom(false)} className="btn btn-ghost btn-sm flex-1">Back</button>
            <button type="button" onClick={handleCustomSubmit} disabled={!date}
              className="btn btn-primary btn-sm flex-1">Schedule</button>
          </div>
        </div>
      )}
    </div>
  )
}
